import parse, {
  domToReact,
  type Element,
  type DOMNode,
} from 'html-react-parser';
import { Heading, Paragraph } from '@hungryroot/ramen';

import styles from './SupplementNutrition.module.css';

const replaceBoldAndParagraphTag = (domNode: DOMNode) => {
  if (domNode.type === 'tag') {
    const element = domNode as Element;
    if (element.name === 'b') {
      return (
        <Heading variant="H6">
          {domToReact(element.children as DOMNode[])}
        </Heading>
      );
    }
    if (element.name === 'p') {
      return <Paragraph>{domToReact(element.children as DOMNode[])}</Paragraph>;
    }
  }
};

const parseOptions = {
  replace: replaceBoldAndParagraphTag,
};

interface SupplementNutritionProps {
  nutritionHtml: string;
}

export function SupplementNutrition({
  nutritionHtml,
}: SupplementNutritionProps) {
  return (
    <div className={styles['supplement-nutrition']}>
      <Heading className={styles.heading} variant="H5">
        Nutrition
      </Heading>
      {parse(nutritionHtml, parseOptions)}
    </div>
  );
}
